import { useQuery } from '@tanstack/react-query';
import { isArray, uniq } from 'lodash';
import { queryClient } from 'src/components/queryProvider';
import { fetchOptimisedScreenSections } from 'src/hooks';
import { ApiResponse } from 'src/interfaces';
import { generateQuery, queryKeys, requestCCApi } from 'src/utils';

import { mapLayoutScreens } from './helpers';

export const useGetLayoutScreens = (
  layoutId?: number | number[],
  enabled: boolean = true,
) =>
  useQuery({
    queryKey: queryKeys.layoutScreens.all(
      layoutId
        ? `layout_id=${isArray(layoutId) ? layoutId.join(' | ') : layoutId}`
        : undefined,
    ),
    queryFn: () => fetchLayoutScreens(layoutId),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: false,
  });

export const fetchLayoutScreens = async (layoutId?: number | number[]) => {
  const url = `/layoutScreens${generateQuery(
    ['layouts', 'screens', 'layoutTypes'],
    [
      'pageSize=0',
      layoutId
        ? `layout_id.list=${isArray(layoutId) ? layoutId.join('|') : layoutId}`
        : '',
    ],
  )}`;

  const response = await requestCCApi({ url });

  const screenIDs: number[] = uniq(
    response.data.map((layoutScreen: ApiResponse) => layoutScreen.screen_id),
  );

  const screens = await queryClient.fetchQuery({
    queryKey: queryKeys.screenSections.all(screenIDs.join('|')),
    queryFn: () => fetchOptimisedScreenSections(screenIDs),
    staleTime: Infinity,
  });

  return mapLayoutScreens(response, screens);
};
